import actionTypes from '../actionTypes';

const initialTransactions = [];
export const currentAgentTransactions = (state = initialTransactions, action) => {
  switch (action.type) {
    case actionTypes.AGENT_TRANSACTION_HISTORY_SUCCESS:
      return action.data;
    case actionTypes.AGENT_TRANSACTION_HISTORY_FAILURE:
      return initialTransactions;
    default:
      return state;
  }
}

const initialAgentDetails = {};

export const currentAgentDetails = (state = initialAgentDetails, action) => {
  switch (action.type) {
    case actionTypes.AGENT_DETAILS_SUCCESS:
      return action.data;
    case actionTypes.AGENT_DETAILS_FAILURE:
      return initialAgentDetails;
    default:
      return state;
  }
}